export default {
  components: {
    styleOverrides: {
      root: ({ theme }: any) => ({
        borderRadius: 8,
        backgroundColor: theme.palette.secondary.main,
        border: 'unset',
        padding: 0,
        '&:hover': {
          backgroundColor: theme.palette.secondary.main,
          border: 'unset'
        }
      }),
      filled: ({ theme }: any) => ({
        border: 'unset',
        '&:hover': {
          backgroundColor: theme.palette.secondary.main,
          border: 'unset'
        }
      }),
      standard: {
        border: 'unset',
        '&:hover': {
          border: 'unset'
        }
      },
      outlined: {
        border: 'unset',
        '&:hover': {
          border: 'unset'
        }
      },
      select: ({ theme }: any) => ({
        padding: theme.spacing(1.5, 3)
      })
    }
  }
};
